document.addEventListener('DOMContentLoaded', function () {

  const steps = document.querySelectorAll('.waiting-list-investment-form__step');

  // Ustaw domyślną wartość selecta z data-city na sekcji
  const section = document.querySelector('.waiting-list-investment-form');
  const city = section?.dataset.city;
  if (city) {
    const citySelect = section.querySelector('select[name="miasto"]');
    if (citySelect) {
      citySelect.value = city;
    }
  }

  document.getElementById('go-investment-waiting-list-step-2')?.addEventListener('click', function (e) {
    e.preventDefault();

    steps[0].classList.remove('active');
    steps[1].classList.add('active');
  });

  // Po wysłaniu formularza CF7
  document.addEventListener('wpcf7mailsent', function (event) {
    const formID = event.target.id;

    if (formID == 'waiting-list-investment-form') {
      steps[1].classList.remove('active');
      steps[2].classList.add('active');
    }
  }, false);

});